import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import loadable from '@loadable/component';

let timeout;

const SlideInCardLoadable = loadable(() =>
  import(/* webpackChunkName: "SlideInCard" */ './SlideInCardLoadable')
);

const SlideInCard = ({ show, animationDuration = 500, ...props }) => {
  const [inDom, setInDom] = useState(false);

  useEffect(() => {
    clearTimeout(timeout);
    if (show) {
      setInDom(true);
    } else {
      timeout = setTimeout(() => {
        setInDom(false);
      }, animationDuration - 50);
    }
  }, [show, animationDuration]);

  return inDom
    ? createPortal(
        <SlideInCardLoadable
          show={show}
          animationDuration={animationDuration}
          {...props}
        />,
        document.body
      )
    : null;
};

export default SlideInCard;
